// extracted by mini-css-extract-plugin
export default {"modal":"update-role-modal_modal__Sltt+"};